import { useState, useEffect } from 'react';
import { getDataWithQueryString } from '../../../../../api/componentAPIs';
import { getExistingFeaturesGeoJSON } from '../Utils';
export const useTerminalGeofence = (terminalId) => {
  const [terminalGeoFenceData, setTerminalGeoFenceData] = useState([]);

  useEffect(() => {
    if (terminalId) {
      getTerminalGeoFence();
    }
  }, [terminalId]);

  const getTerminalGeoFence = () => {
    getDataWithQueryString('GetGeofenceData', `terminalId=${terminalId}`).then(
      (response) => {
        if (response.status >= 200 && response.status < 400) {
          setTerminalGeoFenceData(
            getExistingFeaturesGeoJSON({ id: terminalId, geofence: response.data.geoFence })
          );
        }
      },
      (error) => {
        setTerminalGeoFenceData([]);
      }
    );
  };

  return terminalGeoFenceData;
};
